<div class="d-flex align-items-center justify-content-between">
    <span
        class="d-flex font-sm text-danger"
        [ngbTooltip]="
            invalidFiles.length + unknownFiles.length === 1
                ? ('FILE_VALIDATION.REMOVAL_DIALOG.SINGLE_INVALID_FILES_MESSAGE' | translate)
                : ('FILE_VALIDATION.REMOVAL_DIALOG.NUMBER_OF_MULTIPLE_INVALID_FILES_MESSAGE'
                  | translate: { numberOfFiles: invalidFiles.length + unknownFiles.length })
        "
    >
        <ca-icon name="warning" [removeSVGAttributes]="['stroke']" size="s" class="ca-color-icon-error me-2"></ca-icon>
        {{ invalidFilesMessage }}
    </span>
    <button
        type="button"
        class="btn ca-btn-icon ms-2 justify-item-end"
        data-uit="open-handle-invalid-files-modal-button"
        (click)="openHandleInvalidFilesModal()"
        [ngbTooltip]="tooltipMessage"
        container="body"
        placement="top"
    >
        <ca-icon name="trash" size="s"></ca-icon>
    </button>
</div>
